import {Link, useParams} from 'react-router-dom';

import {QuestionSampleSetDetail} from '~/features/AiSupport/QuestionSampleSets';

export const QuestionSampleSetDetailScene = () => {
  const {questionSampleSetId} = useParams();
  return (
    <div className="bg-background min-h-screen">
      <div className="text-sm breadcrumbs p-4">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/ai-support/question-sample-sets">
              Question Sample Sets
            </Link>
          </li>
          <li>{questionSampleSetId}</li>
        </ul>
      </div>
      <QuestionSampleSetDetail
        questionSampleSetId={questionSampleSetId ?? ''}
      />
    </div>
  );
};
